import type { FinalReportEmailTemplate } from './ProcessReportModal.types';

export const COMPANY_NAME_PLACEHOLDER = '{{COMPANY_NAME}}';
export const CONTACT_NAME_PLACEHOLDER = '{{CONTACT_NAME}}';
export const REPORT_FILENAME_PLACEHOLDER = '{{REPORT_FILENAME}}';
export const DASHBOARD_URL_PLACEHOLDER = '{{DASHBOARD_URL}}';

// Fixed delivery block appended after the user-editable introduction.
// Presets store subject + introduction only; this block is always regenerated.
export const FINAL_REPORT_DELIVERY_SECTION = `Please find attached your final 409A valuation report (${REPORT_FILENAME_PLACEHOLDER}).

You can also review the valuation on your Scalar dashboard here:
${DASHBOARD_URL_PLACEHOLDER}`;

export const FINAL_REPORT_EMAIL_TEMPLATES: FinalReportEmailTemplate[] = [
  {
    id: '409a-final-default',
    label: '409A Final Report Delivery',
    emailSubject: 'Your {{COMPANY_NAME}} 409A valuation report',
    introduction: `Hello {{CONTACT_NAME}},

I am pleased to share the completed 409A valuation report for {{COMPANY_NAME}}.`,
  },
  {
    id: '409a-final-brief',
    label: '409A Final Report (Brief)',
    emailSubject: '{{COMPANY_NAME}} — Final 409A report',
    introduction: `Hi {{CONTACT_NAME}},

Your final 409A valuation report for {{COMPANY_NAME}} is ready.`,
  },
];
